import { post } from './api-client';

export const shoppingCartService = {
    addProductToCartFromCatalog: (productId, data) => post(`/shoppingCart/addProductToCartFromCatalog/${productId}${data}`)
};